import { Switch, Typography } from "@material-ui/core";
import * as React from "react";
import { useEffect, useState } from "react";
import { Animated } from "react-animated-css";
import {
  Accordion,
  AccordionCollapse,
  AccordionToggle,
  Button,
  Dropdown,
  DropdownButton
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader
} from "../../../_metronic/_partials/controls/Card";
import { useSelector } from "react-redux";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import WorkQueueWounds from "../../pages/resident/workqueuewounds";
import PopupModal from "../modal/popupmodal";
import Newresident from "../modal/residentsmodals/newresident";
import ResidentInsuranceComponent from "./InsuranceOptimized";
import ResidentDetails from "./residentdetails";
import FindResident from "./findResident";
import CheckPermission from "../../General/CheckPermission";
import ResidentStatus from "../resident/residentStatus";
import CloseWound from "../resident/closeWound";
import SelectableContext from "react-bootstrap/SelectableContext";
import RBAC, {
  ModulesName,
  UserActions
} from "../../General/roleModuleActions";
import SkipResidentMsg from "./skipResidentMsg";
import SkipWoundMsg from "./skipWoundMsg";
import NewWound from "../resident/newwound";
import ViewWoundInformationChangeReason from "./viewWoundInformationChangeReason";
import AOBManagement from "./AOBManagement";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { WOUND_TYPES } from "../../General/wound-type";

var UpsertNewresident,
  residentStatusModal,
  addStatusRef,
  AddResidentModal,
  insuranceModal,
  woundAmendModal,
  closeWoundModal,
  residentInfoModal,
  noOrderModal,
  showSkipWoundMsgModal,
  editWoundmodal = null;

var _sampleWoundObj = {
  fkResidentId: 0,
  residentName: "",
  facilityName: "",
  roomUnit: "",
  physicanName: "",
  btPatientBrightreeID: null,
  fkLastWoundDetailId: null,
  isWoundInfoChange: false,
  changeReason: "",
  fkSalesOrderId: 0,
  wound: {
    id: 0,
    woundDetailId: 0,
    fkWoundLocationId: null,
    woundLocation: "",
    fkWoundTypeId: null,
    woundDescription: "",
    fkWoundThicknessId: null,
    fkWoundLateralityId: null,
    woundLength: "",
    woundWidth: "",
    woundDepth: "",
    isUtd: false,
    tunneling: false,
    tunnelingDepth: null,
    tunnelingClockPosition: "",
    undermining: false,
    underminingDepth: null,
    underminingClockPosition: null,
    toUnderminingClockPosition: null,
    icdcode: "",
    fkExudateAmountId: null,
    fkExudateTypeId: null,
    exudateColor: "",
    fkDebridementTypeId: null,
    debridementDate: null,
    surgicalDate: null,
    odor: false,
    Pain: false,
    painMedicationOrdered: false,
    sloughPercentage: null,
    necroticPercentage: null,
    cleanseDescription: null,
    fkDressingChangeFrequencyId: 8,
    otherAdditionalPrimaryDressing: "",
    otherAdditionalSecondaryDressing: "",
    treatment: "",
    comments: "",
    thicknessIdForBackStagging: null,
    orientationLeftRight: null,
    orientationUpperLower: null,
    orientationInnerOuter: null,
    orientationAnteriorPosterior: null,
    orientationMedialLateral: null,
    orientationDorsalDistalProximal: null,
    orientationMidline: null,
    isDocumentation: false,
    isPartailOrder: false
  }
};

export function FacilityResident(props) {
  //#region Resident modal / local state
  const [isResidentInfoEdit, setisResidentInfoEdit] = useState(false);
  const [Resident, setResident] = useState("");
  const [ResidentID, setResidentID] = useState("");
  const [isNoOrder, setIsNoOrder] = useState(false);
  const [isProcessorNoOrder, setIsProcessorNoOrder] = useState(false);
  const [activeAccordionKey, setActiveAccordionKey] = useState(null); // null = all closed
  const [residentListUI, setResidentListUI] = useState([]);
  const [partialWoundCount, setPartialWoundCount] = useState(0);
  const [addWoundComponent, setAddWoundComponent] = useState(null);
  const [residentLoading, setResidentLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ShowAdvancedSearch, showAdvanceSearchSectionState] = useState(false);
  const [residentStatus, setResidentStatus] = useState({});
  const [residentListState, setResidentListState] = useState([]);
  const aobButtonVariant = residentListState.some(
    (r) => (r.isMedB === true || r.medicare ) && (!r.aobPdfUrl || r.aobPdfUrl === "")
  ) ? "danger" : "success";
  const [showAOBModal, setShowAOBModal] = useState(false);
  const [isAobEnabled, setIsAobEnabled] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const FacilityId = props.facility.id;
  //#endregion

  useEffect(() => {
    getAllResident();
    Api.getRequest(Api.URI_FeatureSwitch + "2919")
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          const enabled = res.data.result === true || res.data.result === 1 || res.data.result === "1";
          setIsAobEnabled(enabled);
        } else {
          setIsAobEnabled(false);
        }
      })
      .catch(() => setIsAobEnabled(false));
  }, []);

  const getAllResident = () => {
    setIsLoading(true);
    Api.getRequestQry(
      Api.URI_GetAllWorkQueueResidentByFacilityID,
      "?facilityID=" + FacilityId
    )
      .then((res) => {
        if (res.data.statusCode == 200 && res.data.result?.length > 0) {
          const residents = res.data.result;
          setResidentList(residents);
          const medBResidents = residents.filter(r => r.isMedB === true || r.medicare != null)
          setResidentListState(medBResidents);
          
        } else {
          setResidentListUI([]);
        }
      })
      .catch(() => {})
      .then(() => {
        setIsLoading(false);
      });
  };

  const handlePartialWoundCount = (count) => {
    setPartialWoundCount(count);
  };

  const handleResidentStatusToggle = (residentObj) => (event) => {
    try {
      if (residentObj.isNoOrder === true && event.target.checked === false) {
        handleResidentNoOrderStatus(residentObj);
      } else {
        let resident = {};
        resident.ResidentID = residentObj.id;
        resident.Status = event.target.checked;
        updateResidentStatus(resident);
      }
    } catch (ex) {
      Common.LogError(ex, "FacilityResident", "handleResidentStatus");
    }
    };

    const fixImageUrl = (newURL, fileName) => {

        var res = Resident;
        res.imageUrl = newURL;
        res.faceSheetName = fileName;
        setResident(res);

    }

  const updateResidentStatus = (obj) => {
    updateStatus(obj);
  };

  const updateStatus = (obj) => {
    if (obj) {
      setIsLoading(true);
      Api.postRequest(Api.Uri_UpdateSaleOrderStatus, obj).then((res) => {
        if (res.data.success) {
          getAllResident();
          Common.showSuccessAlertAutoClose(
            res.data.message,
            "success",
            "Success!",
            3000
          );
        } else {
          Common.showSuccessAlert(
            res.data.message,
            "warning",
            "Warning!",
            3000
          );
        }
        setIsLoading(false);
      });
    }
  };

  const releaseFacility = () => {
    var msg = "You want to release facility.";
    Common.showConfirmation(msg, "", handleReleaseFacility, null, FacilityId);
  };

  const handleResidentActiveStatus = async (resident) => {
    setResident(resident);
    residentStatusModal.showModal();
  };

  const handleResidentNoOrderStatus = (obj) => {
    let tempObj = JSON.parse(JSON.stringify(obj));
    tempObj.isProcessorNoOrder = false;
    tempObj.isNoOrder = tempObj.isNoOrder ? false : true;
    var msg =
      "" +
      (tempObj.isNoOrder
        ? "You want to no order."
        : "Ordering for this resident was skipped. The No Order will be removed. Do you want to proceed?");
    Common.showConfirmation(msg, "", updateNoOrderStatus, null, tempObj);
  };

  const updateNoOrderStatus = (obj) => {
    if (obj) {
      setIsNoOrder(obj.isNoOrder);
      setIsProcessorNoOrder(obj.isProcessorNoOrder);
      if (obj.isNoOrder) {
        setResidentID(obj.id);
        noOrderModal.showModal();
      } else {
        Api.postRequest(Api.apiUrls.updateResidentNoOrderStatus, {
          msg: "",
          fkResidentId: obj.id,
          isNoOrder: obj.isNoOrder,
          isProcessorNoOrder: obj.isProcessorNoOrder
        }).then((res) => {
          if (res.data.success) {
            getAllResident();
            Common.showSuccessAlertAutoClose(
              "Resident Status Updated Successfully",
              "success",
              "Success!",
              3000
            );
          } else {
            Common.showSuccessAlert(
              res.data.message,
              "error",
              "Error!",
              3000
            );
          }
        });
      }
    }
  };

  const handleNewWound = (newWoundDetail) => {
    setResident(newWoundDetail);
    Common.showConfirmation(
      "Would you like to enter a wound.",
      "",
      handleNewWoundModal,
      null,
      newWoundDetail,
      "Yes",
      false,
      null,
      "No"
    );
  };

  const handleNewWoundModal = (obj) => {
    let residenObj = JSON.parse(JSON.stringify(_sampleWoundObj));
    residenObj.fkResidentId = obj.id;
    residenObj.residentName =
      Common.replaceNullWithString(obj.firstName) +
      " " +
      Common.replaceNullWithString(obj.lastName);
    residenObj.facilityName = Common.replaceNullWithString(
      props.facility.facilityName
    );
    residenObj.roomUnit =
      Common.replaceNullWithString(obj.room) +
      "/" +
      Common.replaceNullWithString(obj.unit);
    residenObj.physicanName = Common.replaceNullWithString(
      obj.primaryPhysicianName
    );
    residenObj.btPatientBrightreeID = obj.btPatientBrightreeID;

    if (obj.fkResidentStatusId == Common.ResidentStatusID.open) {
      setAddWoundComponent(
        <NewWound
          refresh={props.refresh}
          isEdit={false}
          isReorder={false}
          showProduct={false}
          isReadOnly={false}
          user={user}
          displayProduct={true}
          queue={props.queue || Common.ProcessStatus.workQueueID}
          resident={residenObj}
          close={() => handleCloseWoundmodalPopup()}
        />
      );
      editWoundmodal.showModal();
    } else {
      Common.showSuccessAlert(
        "Resident is not open please update resident status to add/update new wound",
        "warning",
        "Warning!",
        3000
      );
    }
  };

  const handleCloseWoundmodalPopup = () => {
    editWoundmodal.hideModal();
    getAllResident();
  };

  const handleReleaseFacility = (facilityID) => {
    setIsLoading(true);
    var obj = {};
    obj.FacilityID = facilityID;
    obj.billingDate = props.facility.cycleDate;
    obj.isSecondaryCycle = props.facility.isSecondaryCycle;

    Api.postRequest(Api.Uri_UpdateFacilityStatus, obj)
      .then((res) => {
        if (res.data.success) {
          Common.showSuccessAlertAutoClose(
            res.data.message,
            "success",
            "Success!",
            3000
          );
          props.backPress();
        } else {
          Common.showSuccessAlert(
            res.data.message,
            "warning",
            "Warning!",
            3000
          );
        }
      })
      .catch((ex) => {
        Common.showSuccessAlertAutoClose(
          ex.message,
          "warning",
          "Failed!",
          3000
        );
      })
      .then(() => {
        setIsLoading(false);
      });
  };

  const setResidentList = (list) => {
    const uniqueList = list.filter((r, i, arr) => arr.findIndex((x) => x.id === r.id) === i);
    const rows = uniqueList.map((obj) => {
      const eventKey = obj.id.toString();
      const name = `${obj.lastName}, ${obj.firstName}`;
      const insurance =
        obj.residentInsuranceList?.length > 0
          ? obj.residentInsuranceList
              .map(
                (ins) =>
                  `${ins.isAddEdit ? "*" : ""}${ins.insuranceName}`
              )
              .join(", ")
          : "No insurance on file";

      const isProcessed = obj.isProcess || obj.isNoOrder;
      const statusText = obj.isNoOrder
        ? "Skipped"
        : obj.isProcess
        ? "Processed"
        : "Pending";
      const statusBadge = isProcessed ? "badge-success" : "badge-warning";
      const headerBg = obj.isNoOrder
        ? "bg-light-warning"
        : obj.isProcess
        ? "bg-light-success"
        : "";

      return (
        <Card key={obj.id} className="mb-4 shadow-sm">
          <CardHeader className="p-0">
            <AccordionToggle
              as="div"
              eventKey={eventKey}
              className="w-100"
              style={{ cursor: "pointer" }}
            >
              <div
                className={`d-flex align-items-center px-4 py-3 border-bottom ${headerBg}`}
              >
                {/* Left: Resident Name + Info */}
                <div className="flex-grow-1">
                  <div
                    className={`h5 mb-1 ${
                      !obj.fkPrimaryPhysicianId ? "text-danger" : ""
                    }`}
                    title={
                      !obj.fkPrimaryPhysicianId &&
                      "Primary physician is not assigned"
                    }
                  >
                    {name} - BT ID: {obj.btPatientBrightreeID || "N/A"}
                  </div>
                  {!obj.fkPrimaryPhysicianId && (
                    <small className="text-danger">
                      Primary physician is not assigned
                    </small>
                  )}
                  <br />
                  <small className="text-muted">{insurance}</small>
                </div>

                {/* Right: badges / switch / actions */}
                <div
                  className="d-flex align-items-center"
                  onClick={(e) => e.stopPropagation()}
                >
                  {obj.isEcp && (
                    <span className="badge badge-success mr-2">ECP</span>
                  )}

                  <span className={`badge badge-lg ${statusBadge} mr-4`}>
                    {statusText}
                  </span>

                  <Switch
                    checked={isProcessed}
                    onChange={handleResidentStatusToggle(obj)}
                    onClick={(e) => e.stopPropagation()}
                    color="primary"
                  />

                  <SelectableContext.Provider value={false}>
                    <DropdownButton
                      drop="down"
                      variant="primary"
                      size="sm"
                      title="Actions"
                      className="ml-2"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <CheckPermission
                        permission={UserActions.Update}
                        module={ModulesName.Module_Residents}
                        yes={() => (
                          <>
                            <Dropdown.Item
                              onClick={() => {
                                setResident(obj);
                                setisResidentInfoEdit(false);
                                residentInfoModal.showModal();
                              }}
                            >
                              Resident Info
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() =>
                                handleResidentActiveStatus(obj)
                              }
                            >
                              Set Resident Status
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setResident(obj);
                                closeWoundModal.showModal();
                              }}
                            >
                              Show Closed Wound
                            </Dropdown.Item>

                            {(props.facility.fkProcessStatusId ===
                              Common.ProcessStatus.billingQueueID ||
                              props.facility.fkProcessStatusId ===
                                Common.ProcessStatus.workQueueID) && (
                              <CheckPermission
                                userRole={[
                                  RBAC.Role_Gentell_SeniorBiller,
                                  RBAC.Role_Gentell_IntakeProcessor,
                                  RBAC.Role_Gentell_Administrator,
                                  RBAC.Role_Gentell_WoundCareSpecialist,
                                  RBAC.Role_Gentell_RegionalManager
                                ]}
                                yes={() => (
                                  <Dropdown.Item
                                    onClick={() =>
                                      handleResidentNoOrderStatus(obj)
                                    }
                                  >
                                    {obj.isNoOrder
                                      ? "Order Products"
                                      : "No Order"}
                                  </Dropdown.Item>
                                )}
                              />
                            )}

                            <Dropdown.Item
                              onClick={() => {
                                setResidentID(obj.id);
                                showSkipWoundMsgModal.showModal();
                              }}
                            >
                              View Skip Wound Messages
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setResidentID(obj.id);
                                woundAmendModal.showModal();
                              }}
                            >
                              View Wound Amend Details
                            </Dropdown.Item>
                          </>
                        )}
                      />
                    </DropdownButton>
                  </SelectableContext.Provider>
                </div>
              </div>
            </AccordionToggle>
          </CardHeader>

          <AccordionCollapse
            eventKey={eventKey}
            mountOnEnter
            unmountOnExit
          >
            <CardBody className="pt-0">
              <fieldset disabled={isProcessed}>
                <WorkQueueWounds
                  facility={props.facility}
                  isShowProduct={true}
                  refresh={getAllResident}
                  isProcess={obj.isProcess}
                  Resident={obj}
                  setPartialWoundCount={handlePartialWoundCount}
                />
              </fieldset>
            </CardBody>
          </AccordionCollapse>
        </Card>
      );
    });

    setResidentListUI(rows);
    Common.LoadDataTable("residentsList");
  };

  const showAdvanceSearchSection = () => {
    showAdvanceSearchSectionState(!ShowAdvancedSearch);
  };

  const handleAOBManagement = () => {
    // Open the AOB Management modal
    // const medBResidents = residentListState.filter((r) => r.isMedB === true);
    if (residentListState.length === 0) {
      Common.showSuccessAlert(
        "No residents with Medicare present",
        "warning",
        "No Medicare Residents"
      );
      return;
    }
    setShowAOBModal(true);
  };

  const handleShowAddResident = (obj) => {
    setResident(obj);
    AddResidentModal.showModal();
  };

  const toolbar = (
    <div className="card-toolbar">
      <div className="example-tools">
        <CheckPermission
          permission={UserActions.View}
          module={ModulesName.Module_Residents}
          yes={() => (
            <Button
              variant="primary"
              size="sm"
              className="mr-2"
              onClick={() => {
                handleShowAddResident(null);
              }}
            >
              New Resident
            </Button>
          )}
        />
        <CheckPermission
          permission={UserActions.View}
          module={ModulesName.Module_Residents}
          yes={() => (
            <Button
              className="mr-2"
              variant="warning"
              size="sm"
              onClick={showAdvanceSearchSection}
            >
              Find Resident
            </Button>
          )}
        />
        {isAobEnabled && (
          <Button
            className="mr-2"
            variant={aobButtonVariant}
            size="sm"
            onClick={handleAOBManagement}
            disabled={isLoading}
            style={{
              backgroundColor: aobButtonVariant === "danger" ? "#DC3545" : "#28A745",
              borderColor: aobButtonVariant === "danger" ? "#DC3545" : "#28A745",
              color: "#fff",
            }}
          >
            AOB Management
          </Button>
        )}
        {/* <CheckPermission
          permission={UserActions.View}
          module={ModulesName.Module_Residents}
          yes={() => (
            <Button
              className="mr-2"
              // variant="warning"
              variant={(()=>{
                const isPartB = props.facility?.medicarePartBbyGentell === true;
                const partBResidents = isPartB ? residentListState : [];
                const allPartBHaveAob = partBResidents.length === 0 || partBResidents.every(
                  (r) => r.aobPdfUrl != null && String(r.aobPdfUrl).trim() !== ""
                );
                return allPartBHaveAob ? "success" : "warning";
              })()}
              size="sm"
              onClick={
                () => {showAdvanceSearchSection();}
                // ()=>{handleShowAOBManagement()}
              }
            >
              AOB Management
            </Button>
          )}
        /> */}
        <CheckPermission
          permission={UserActions.Update}
          module={ModulesName.Module_MyWorkQueue}
          yes={() => (
            <button
              type="button"
              className="mr-1 btn btn-success btn-sm"
              onClick={releaseFacility}
            >
              Release Facility
            </button>
          )}
        />
        <button
          type="button"
          className="mr-2 btn btn-dark btn-sm"
          onClick={props.backPress}
        >
          Back To Facility List
        </button>
      </div>
    </div>
  );

  return (
    <>
      {ShowAdvancedSearch && (
        <Animated
          animationIn="fadeInLeft"
          animationInDuration={800}
          animationOut="fadeOut"
          isVisible={ShowAdvancedSearch}
        >
          <FindResident
            createWoundType={WOUND_TYPES.EVALUATION}
            user={user}
            facility={props.facility}
            refresh={getAllResident}
            facilityId={FacilityId}
            closeSearch={showAdvanceSearchSection}
          />
        </Animated>
      )}

      <Card className="example example-compact">
        <CardHeader>
          <div className="row">
            <div className="col-sm-7 col-md-7 col-lg-7 col-xl-7">
              <div className="card-title ">
                <span>
                  Facility:{" "}
                  <b className="text-success">
                    {props.facility.facilityName}
                  </b>
                  , Purchasing Group-Chain:{" "}
                  {props.facility.chain === "" ? "N/A" : props.facility.chain}
                  , Ownership/Headquarters:{" "}
                  {props.facility.organizationName === ""
                    ? "N/A"
                    : props.facility.organizationName}
                  ,
                  <br />
                  Ship Date:{" "}
                  {Common.GetDateString(props.facility.cycleDate) ===
                    "01-01-01" || props.facility.cycleDate == null
                    ? "N/A"
                    : Common.GetDateString(props.facility.cycleDate) +
                      (props.facility.isSecondaryCycle ? " (S)" : "")}
                  <b>
                    <FormControlLabel
                      label={
                        <Typography>
                          <h4 className="mt-4"> Part B:</h4>
                        </Typography>
                      }
                      labelPlacement="start"
                      control={
                        <Checkbox
                          className="mt-2"
                          checked={
                            props.facility.medicarePartBbyGentell
                          }
                          value="checkedA"
                        />
                      }
                    />
                    <FormControlLabel
                      label={
                        <Typography>
                          <h4 className="mt-4"> Equal Care:</h4>
                        </Typography>
                      }
                      labelPlacement="start"
                      control={
                        <Checkbox
                          className="mt-2"
                          checked={props.facility.isEcp}
                          value="checkedB"
                        />
                      }
                    />
                    <FormControlLabel
                      label={
                        <Typography>
                          <h4 className="mt-4">Outs:</h4>
                        </Typography>
                      }
                      labelPlacement="start"
                      control={
                        <Checkbox
                          className="mt-2"
                          checked={props.facility.outProgram}
                          value="checkedC"
                        />
                      }
                    />
                  </b>
                  <h3 className="card-label mt-3">Resident List</h3>
                  {props.facility.totalPartailWound > 0 && (
                    <h3 className="card-label">
                      Total number of partial wounds{" "}
                      {props.facility.totalPartailWound}
                    </h3>
                  )}
                </span>
              </div>
            </div>
            <div className="col-sm-5 col-md-5 col-lg-5 col-xl-5">
              {toolbar}
            </div>
          </div>
        </CardHeader>
        <CardBody>
          {isLoading ? (
            <div className="row d-flex justify-content-center">
              <span className="mt-5 spinner spinner-primary"></span>
            </div>
          ) : (
            <Accordion
              activeKey={activeAccordionKey ?? undefined}
              onSelect={(key) =>
                setActiveAccordionKey((prev) =>
                  prev === key ? null : key
                )
              }
            >
              {residentListUI}
            </Accordion>
          )}
        </CardBody>
      </Card>

      {/* Modals */}

      <PopupModal
        title="Insurances"
        showButton={false}
        ref={(ref) => {
          insuranceModal = ref;
        }}
      >
        <ResidentInsuranceComponent residentID={ResidentID} />
      </PopupModal>

      <PopupModal
        title="Resident Info"
        dialogClassName="modal-90w"
        showButton={false}
        ref={(ref) => {
          residentInfoModal = ref;
        }}
        onClose={(ref) => {
          Common.showConfirmation(
            "Are you sure you want to close without saving the data?",
            "Warning",
            () => {
              ref.setState({ show: false });
            },
            () => {},
            null,
            "Exit Without Saving"
          );
        }}
      >
        {isResidentInfoEdit && (
          <Animated
            animationIn="fadeIn"
            animationInDuration={800}
            animationOut="fadeOut"
          >
            <div className="row d-flex align-items-center justify-content-end">
              <Button
                className="mb-4 mr-4 "
                onClick={() =>
                  setisResidentInfoEdit(!isResidentInfoEdit)
                }
              >
                Go Back To Detail
              </Button>
            </div>
            <Newresident
              ref={(ref) => {
                UpsertNewresident = ref;
              }}
              FacilityId={FacilityId}
              Resident={Resident}
              setResidentLoading={setResidentLoading}
              facility={props.facility}
              close={() => {
                getAllResident();
                setResidentLoading(false);
                residentInfoModal.hideModal(true);
              }}
            />
            <div className="row d-flex align-items-center justify-content-end">
              <Button
                className="mb-4 btn-success ml-2"
                disabled={residentLoading}
                onClick={() => UpsertNewresident.handleSubmit()}
              >
                <span
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {residentLoading && (
                    <span className="mr-8 spinner spinner-white"></span>
                  )}
                  <span>Save Changes</span>
                </span>
              </Button>
            </div>
          </Animated>
        )}

        {!isResidentInfoEdit && (
          <Animated
            animationIn="fadeIn"
            animationInDuration={800}
            animationOut="fadeOut"
          >
            <div className="row d-flex align-items-center justify-content-end">
              <Button
                className="mb-4 mr-4"
                onClick={() =>
                  setisResidentInfoEdit(!isResidentInfoEdit)
                }
              >
                Edit
              </Button>
            </div>
            <ResidentDetails
              resident={Resident}
                          getAllResident={getAllResident}
                          fixImageUrl={fixImageUrl}
            />
          </Animated>
        )}
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Wound Amend Messages</h3>
              <small>
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName === ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain === ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        dialogClassName="modal-90w"
        showButton={false}
        ref={(ref) => {
          woundAmendModal = ref;
        }}
      >
        <ViewWoundInformationChangeReason
          residentId={ResidentID}
          woundId={0}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Resident Status</h3>
              <small>
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName === ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain === ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        ref={(ref) => {
          residentStatusModal = ref;
        }}
        showButton={true}
        buttonPress={() => addStatusRef.onSubmit()}
        module={ModulesName.Module_Residents}
        action={UserActions.Update}
      >
        <ResidentStatus
          ref={(ref) => {
            addStatusRef = ref;
          }}
          resident={Resident}
          close={() => {
            getAllResident();
            residentStatusModal.hideModal();
          }}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Resident Close Wound</h3>
              <small>
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName === ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain === ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        dialogClassName="modal-95w"
        ref={(ref) => {
          closeWoundModal = ref;
        }}
      >
        <CloseWound
          resident={Resident}
          close={() => {
            getAllResident();
          }}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Add Resident</h3>
              <small>
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName === ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain === ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        dialogClassName="modal-97w"
        showButton={true}
        ref={(ref) => {
          AddResidentModal = ref;
        }}
        buttonDisabled={residentLoading}
        buttonPress={() => UpsertNewresident.handleSubmit()}
        module={ModulesName.Module_Residents}
        action={UserActions.Create}
        onClose={(ref) => {
          Common.showConfirmation(
            "Are you sure you want to close without saving the data?",
            "Warning",
            () => {
              ref.setState({ show: false });
            },
            () => {},
            null,
            "Exit Without Saving"
          );
        }}
      >
        <Newresident
          ref={(ref) => {
            UpsertNewresident = ref;
          }}
          userID={user.userID}
          user={user}
          FacilityId={props.facility.id}
          facility={props.facility}
          handleNewWound={handleNewWound}
          setResidentLoading={setResidentLoading}
          close={() => {
            getAllResident();
            setResidentLoading(false);
            AddResidentModal.hideModal(true);
          }}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Skip Resident Message</h3>
              <small>
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName === ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain === ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        showButton={false}
        ref={(ref) => {
          noOrderModal = ref;
        }}
      >
        <SkipResidentMsg
          msg={null}
          fkResidentId={ResidentID}
          isNoOrder={isNoOrder}
          isProcessorNoOrder={isProcessorNoOrder}
          onSave={() => {
            noOrderModal.hideModal();
            getAllResident();
          }}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Skip Wounds Message</h3>
              <small>
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName === ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain === ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        showButton={false}
        ref={(ref) => {
          showSkipWoundMsgModal = ref;
        }}
      >
        <SkipWoundMsg
          fkResidentId={ResidentID}
          isNoOrder={isNoOrder}
          isProcessorNoOrder={isProcessorNoOrder}
          onSave={() => {
            showSkipWoundMsgModal.hideModal();
          }}
        />
      </PopupModal>

      <PopupModal
        onClose={(ref) => {
          getAllResident();
          ref.setState({ show: false });
        }}
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Wound Evaluation</h3>
            </span>
          </div>
        }
        dialogClassName="modal-95w"
        ref={(ref) => {
          editWoundmodal = ref;
        }}
      >
        {addWoundComponent}
      </PopupModal>

      {/* AOB Management Modal */}
      <AOBManagement
        open={showAOBModal}
        onClose={() => setShowAOBModal(false)}
        facilityId={FacilityId}
        facilityName={props.facility?.facilityName}
        props={props}
        residentList={residentListState}
        onRefresh={getAllResident}
      />
    </>
  );
}

export default FacilityResident;
